import { Tag } from 'antd';
import { trangThaiTongHopDangKyDaoTao } from '../../constants';

const trangThaiTagMap: Record<number, { color: string; label: string }> = {
    [trangThaiTongHopDangKyDaoTao.khoiTao]: { color: "processing", label: "Khởi tạo" },
    [trangThaiTongHopDangKyDaoTao.thuHoi]: { color: "warning", label: "Thu hồi" },
    [trangThaiTongHopDangKyDaoTao.trinhPhoCVP]: { color: "purple", label: "Trình phó chánh văn phòng" },
    [trangThaiTongHopDangKyDaoTao.phoCVPTraLai]: { color: "error", label: "Phó chánh văn phòng từ chối" },
    [trangThaiTongHopDangKyDaoTao.trinhCVP]: { color: "cyan", label: "Trình chánh văn phòng" },
    [trangThaiTongHopDangKyDaoTao.chanhVPTraLai]: { color: "error", label: "Chánh văn phòng từ chối" },
    [trangThaiTongHopDangKyDaoTao.trinhPhoGiamDoc]: { color: "blue", label: "Trình Phó Giám đốc" },
    [trangThaiTongHopDangKyDaoTao.phoGiamDocTraLai]: { color: "error", label: "Phó Giám đốc từ chối" },
    [trangThaiTongHopDangKyDaoTao.trinhGiamDoc]: { color: "gold", label: "Trình lãnh đạo đơn vị" },
    [trangThaiTongHopDangKyDaoTao.giamDocTraLai]: { color: "error", label: "Lãnh đạo đơn vị từ chối" },
    [trangThaiTongHopDangKyDaoTao.pheDuyet]: { color: "success", label: "Duyệt" },
    [trangThaiTongHopDangKyDaoTao.banHanh]: { color: "green", label: "Ban hành" },
};

const TrangThaiTongHopTag = ({ value }: { value?: number }) => {
    if (value === undefined || value === null) return null;

    const config = trangThaiTagMap[value];

    if (!config) return <span></span>;

    return <Tag color={config.color}>{config.label}</Tag>;
};

export default TrangThaiTongHopTag;
